import request from '@/utils/request'

//  新增虚拟商品
export const addVirtualGoods = (formData) => {
    return request.post('/virtualGoods', formData)
}

//  修改商品
export const editVirtualGoods = (updateData) => {
    return request.put(`/virtualGoods/${updateData.goodsId}`, updateData)
}

// 修改活动状态
export const editActivityState = (updateData) => {
    return request.put(`/virtualGoods/activity/state?goodsId=${updateData.goodsId}&activityState=${updateData.activityState}`)
}
// 修改活动状态
export const editActivityStateAdmin = (updateData) => {
    return request.put(`/activity/management/activityState?goodsId=${updateData.goodsId}&activityState=${updateData.activityState}`)
}

// 修改比赛状态
export const editCompetitionState = (updateData) => {
    return request.put(`/virtualGoods/competition/state?goodsId=${updateData.goodsId}&competitionState=${updateData.competitionState}`)
}
